import * as React from "react";
import { forwardRef } from "react";
const SvgIconReports = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 18, viewBox: "0 0 20 18", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14 8V0H6V6H0V18H20V8H14ZM8 2H12V16H8V2ZM2 8H6V16H2V8ZM18 16H14V10H18V16Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIconReports);
export { ForwardRef as ReactComponent };
